<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <form
      class="flex w-[330px] flex-col py-[50px]"
      [formGroup]="resetPasswordForm"
      (ngSubmit)="resetPassword()"
    >
      <div class="text-s2 text-center text-2xl font-semibold">{{
        pageTitle
      }}</div>
      <div class="text-s1 mt-9 text-center text-base"
        >Please enter the email address you used to log in. We will send you a
        link to reset your password.</div
      >

      <input
        spellcheck="false"
        data-cy="forgotPasswordEmailInput"
        class="form-input border-s3 focus:border-m600 mt-6 h-11 rounded"
        [ngClass]="{
          'border-r600':
            resetPasswordForm.controls['email'].invalid &&
            resetPasswordForm.controls['email'].touched
        }"
        type="email"
        formControlName="email"
        placeholder="Email"
      />
      <m-validation
        [control]="resetPasswordForm.controls['email']"
      ></m-validation>

      <button
        data-cy="forgotPasswordResetPasswordButton"
        class="bg-m600 text-m0 mt-1 rounded-md py-3 text-lg font-medium focus:outline-none"
        type="submit"
        >Reset Password</button
      >
      <div class="flex flex-row justify-center">
        <button
          type="button"
          class="text-m600 mt-6 w-36 text-center text-base focus:outline-none"
          (click)="backToLogin()"
          >Back to Log In</button
        >
      </div>
    </form>
  </div>
</div>
